<template>
    <div id="main-content">
        <h1 class="text-center font-weight-normal" style="margin-top: 8rem;position: absolute;width: 100%;">Oops, you don't have access or the page is not found</h1>
        <h4 class="m-5 position-absolute">You will be redirected in {{ countDown }} </h4>
    </div>
</template>

<script>
export default{
    data() {
        return { 
            countDown: 3
        }
    },
    methods:{
        countDownTimer(){
            if(this.countDown > 0){
                setInterval(() => {
                    this.countDown--
                    this.countDownTimer
                }, 1000)
            } else {
                return
            }  
        }
    },
    mounted:function(){
        this.countDownTimer()
    },
    watch: {
        countDown:{
            handler(newVal) {
                if(newVal == 0 || newVal < 0) { 
                    this.$router.push({ path: '/', name:'index' })
            }  
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width:979px) { 
    #main-content{ 
        background-size: 100% !important; 
    }
}
#main-content{
    background: url('/src/assets/images/bg/restricted-gb.jpg');
    height: 100%;
    width: 100%;
    background-size: 50vw;
    background-position-y: center;
    background-repeat: no-repeat;
    background-position-x: center;
}
</style>